import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import StarRating from '../StarComponent'
import UserService from '../../services/UserService'
import logoutPopupModel from '../logoutPopupModal/index.vue'
import { showSuccessToast } from '../../services/UI'
export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      user: '',
      navOpen: true,
      logoutModalActive: false
    }
  },
  components: {
    StarRating,
    logoutPopupModel
  },
  async created () {
    this.user = await UserService.getUser()
    console.log(this.user)
  },
  computed: {},
  methods: {
    actionLogout () {
      this.logoutModalActive = true
      document.body.classList.add('reject_modal_open')
    },
    async closeLogout (bool) {
      if (!bool) this.logoutModalActive = !this.logoutModalActive
      else this.logoutModalActive = null
      document.body.classList.remove('reject_modal_open')
      // this.jobs = await JobService.listMiniJobShiftLogs()
    },
    async logout () {
      await UserService.logout()
      this.$router.push('/sign_in')
      showSuccessToast(this, 'Logged Out')
    }
  }
}
